@if (allFilters$ | async; as allFilters) {
  @if (allFilters.length) {
    <div class="filtering">
      <cyborg-facet-buttons
        [facets]="allFilters$ | async"
        [groupByCategory]="false"
      ></cyborg-facet-buttons>
    </div>
  }
}

<div class="clear-all">
  <hyperkit-button
    size="small"
    variant="link"
    color="primary"
    text="Clear All Filters"
    (click)="onClearAllFilters()"
  ></hyperkit-button>
</div>
